import { css } from '@emotion/react'

export const styles = () => ({
  tracks: {
    main: css``,
  },
})
